import * as Sentry from "@sentry/react";
import html2canvas from "html2canvas";

import { createSentryAttachment } from "./create-attachment";

export async function captureSentryErrorScreenshot(eventId: string) {
  try {
    const canvas = await html2canvas(document.documentElement, {
      logging: false,
      useCORS: true,
    });
    const blob = await new Promise<Blob | null>((resolve) =>
      canvas.toBlob(resolve, "image/png"),
    );

    if (!blob) {
      return;
    }

    const attachment = createSentryAttachment(
      "screenshot.png",
      await blob.arrayBuffer(),
    );

    Sentry.captureFeedback(
      {
        associatedEventId: eventId,
        message: "Automatický screenshot při zachycení chyby.",
        url: window.location.href,
      },
      { attachments: [attachment] },
    );
  } catch {
    // Screenshot must not prevent the error fallback from being displayed.
  }
}
